import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { environment } from '../../../environments/environment';

class Decision {
  id: number;
  attachedFileId: string;
  documentTemplateFileId: string;
  type: number;
  petitionStatusId: number;
}

@Component({
  selector: 'app-decision-dialog',
  templateUrl: './decision-dialog.component.html',
  styleUrls: ['./decision-dialog.component.scss']
})
export class DecisionDialogComponent implements OnInit {

  /**
   * Title map
   */
  private readonly _titleMap: { [key: string]: string; } = {
    "2": "ხმის მიცემის დაწყება",
    "3": "ხმის მიცემის შეწყვეტა",
    "4": "დახარვეზება"
  };

  /**
   * Status title map
   */
  private readonly _statusTitleMap: { [key: string]: string; } = {
    "4": "დაბლოკვა",
    "10": "უარყოფა",
    "15": "თანხმობა"
  };

  /**
   * Type to title map
   */
  private readonly _typeMap: { [key: string]: number[]; } = {};

  /**
   * Status to title map
   */
  private readonly _statusMap: { [key: string]: number[]; } = {
    "4": [5],
    "10": [17]
  };

  /**
   * Constructor
   *
   * @param data
   */
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  /**
   * Init
   */
  ngOnInit() {
  }

  /**
   * Returns decision title by type
   *
   * @param decision
   * @param defaultTitle
   */
  getDecisionTitle(decision: Decision, defaultTitle: string = 'შეტყობინება') {
    const titleMapIndex = Object.keys(this._typeMap).find((key) => this._typeMap[key].indexOf(decision.type) >= 0);

    if (titleMapIndex) {
      return this._titleMap[titleMapIndex];
    } else if (this._titleMap[decision.type]) {
      return this._titleMap[decision.type];
    }

    const statusTitleMapIdex = Object.keys(this._statusMap).find((key) => this._statusMap[key].indexOf(decision.petitionStatusId) >= 0);

    if (statusTitleMapIdex) {
      return this._statusTitleMap[statusTitleMapIdex];
    } else if (this._statusTitleMap[decision.petitionStatusId]) {
      return this._statusTitleMap[decision.petitionStatusId];
    }

    return defaultTitle;
  }

  attachedFileId(attachedFileId: string): string {
    return this.documentTemplateFileId(attachedFileId);
  }

  documentTemplateFileId(documentTemplateFileId: string):string {
    return new URL(`/idea/file/${documentTemplateFileId}`, environment.apiUlr).toString()
  }

}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/components/decision-dialog/decision-dialog.component.ts